const getData = res => res.data.data;

export default getData;
